import MoodleReaderNode from './types/moodle-reader';
import MoodleWriterNode from './types/moodle-writer';

export const moodleNodes = {
  moodleReader: MoodleReaderNode,
  moodleWriter: MoodleWriterNode,
};
